export default {
  navigationBarTitleText: '项目验收'
};
